import { render, staticRenderFns } from "./ReporteAbandonoLeads.vue?vue&type=template&id=c1f4e84e"
import script from "./ReporteAbandonoLeads.vue?vue&type=script&lang=js"
export * from "./ReporteAbandonoLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports